/**
 * Created by laszlo.czondor on 2017. 08. 31.
 */
import uuid from 'uuid/v4';
import Cookies from 'js-cookie';
import getDomain from './get-domain';

const COOKIE_NAME = 'sa-cookie';
const COOKIE_LIFESPAN_IN_DAYS = 365;

const DEFAULT_ATTRS = ['layoutId', 'moduleName', 'description'];

const URL = '/_rama_analytics';

const SEND_INTERVAL = 1000; // in millisecs

const COOKIE_DEFAULTS = {
	expires: COOKIE_LIFESPAN_IN_DAYS,
	path: '/',
	domain: getDomain()
};

function getMouseButton(event) {
	let result;
	if (event.type === 'mousedown') {
		switch (event.which) {
			case 0:
				result = 'No button';
				break;
			case 1:
				result = 'Left button';
				break;
			case 2:
				result = 'Middle button';
				break;
			case 3:
				result = 'Right button';
				break;
			default:
				result = null;
				break;
		}
	} else {
		result = null;
	}

	return result;
}

function prepareData(event, element, attr) {
	let documentDimensions = document.body.getBoundingClientRect();

	// width and height of the whole webpage
	let page = {
		height: documentDimensions.height,
		width: documentDimensions.width
	};

	// width and height of user computer screen
	let screen = {
		height: event.view.screen.height,
		width: event.view.screen.width
	};

	// width and height of desktop viewport and scrolled position
	let viewport = {
		height: event.view.innerHeight,
		width: event.view.innerWidth,
		scrollX: event.view.scrollX,
		scrollY: event.view.scrollY
	};
	let layoutId = attr.layoutId || null;
	let moduleName = attr.moduleName || null;
	let eventDescription = attr.description || null;

	let eventType = event.type || null;
	let coordX = (typeof event.pageX !== 'undefined') ? event.pageX : null;
	let coordY = (typeof event.pageY !== 'undefined') ? event.pageY : null;

	let result = {
		// default properties
		eventType: eventType,
		eventDescription: eventDescription,
		viewport: JSON.stringify(viewport),
		coordX: coordX,
		coordY: coordY,
		layoutID: layoutId,
		moduleName: moduleName,
		// custom properties
		screen: JSON.stringify(screen),
		page: JSON.stringify(page),
		mouseEvent: getMouseButton(event)
	};

	// add the remaining attributes
	for (let attribute in attr) {
		if (DEFAULT_ATTRS.indexOf(attribute) === -1) {
			result['sa-' + attribute] = attr[attribute];
		}
	}

	return result;
}

function queueEvent(queue, event, element, binding) {
	let data = prepareData(event, element, binding.value);

	queue.push(data);
}

function init(element, binding) {
	let myCookie = Cookies.get(COOKIE_NAME);
	let queue = [];

	if (myCookie) {
		// update cookie
		Cookies.set(COOKIE_NAME, myCookie, COOKIE_DEFAULTS);
	} else {
		let myId = uuid();
		Cookies.set(COOKIE_NAME, myId, COOKIE_DEFAULTS);
	}

	element.addEventListener('blur', function (event) {
		queueEvent(queue, event, element, binding);
	}, false);
	element.addEventListener('focus', function (event) {
		queueEvent(queue, event, element, binding);
	}, false);
	element.addEventListener('mousedown', function (event) {
		queueEvent(queue, event, element, binding);
	}, false);
//FIXME nem tudom mi ez de biztos kell majd
	// setInterval(function () {
	// 	if (queue.length) {
	// 		let data = JSON.stringify(queue);
	// 		let request = new XMLHttpRequest();
	// 		request.open('POST', URL, true);
	// 		request.setRequestHeader('Content-Type', 'application/json');
	// 		request.send(data);

	// 		// reset queue
	// 		queue = [];
	// 	}
	// }, SEND_INTERVAL);
}

export default {
	inserted: init
};



// WEBPACK FOOTER //
// ../source/common/analytics/rama-analytics.js